/**
 * Smart backend URL resolver
 * Returns the correct backend URL for the current environment
 * Caches the result after first call for performance
 */

// Cache the resolved URL to avoid repeated calculations
let cachedBackendUrl = null;

export const getBackendUrl = () => {
  // Return cached value if already resolved
  if (cachedBackendUrl !== null) {
    return cachedBackendUrl;
  }

  // Check if REACT_APP_BACKEND_URL is set
  const envBackendUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If environment variable is set, ALWAYS use it (trust the deployment config)
  if (envBackendUrl) {
    console.log('[getBackendUrl] Using configured backend URL:', envBackendUrl);
    cachedBackendUrl = envBackendUrl;
    return cachedBackendUrl;
  }
  
  // Only fall back to current domain if no env URL is set
  if (typeof window !== 'undefined' && window.location) {
    const currentDomain = window.location.origin;
    console.log('[getBackendUrl] No REACT_APP_BACKEND_URL set, using current domain:', currentDomain);
    cachedBackendUrl = currentDomain;
    return cachedBackendUrl;
  }
  
  // Fallback for SSR or non-browser contexts
  cachedBackendUrl = '';
  return cachedBackendUrl;
};

// Function to clear cache (useful for testing or if domain changes)
export const clearBackendUrlCache = () => {
  cachedBackendUrl = null;
};

export default getBackendUrl;
